exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".products_count[data-v-99d06364]{color:#0e8ce4;font-weight:700}", ""]);

// exports
